<template>
  <div>
    <rp-gencode
      v-model="accessCodeData"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import page from '@/mixins/page'
import GenerateAccessCode from 'raypro_ui/src/components/ui/forms/GenerateAccessCode'
import {getAccessCode} from 'raypro_ui/src/api/access_codes'

export default {
  components: {
    'rp-gencode': GenerateAccessCode
  },

  mixins: [page],

  data() {
    return {
      title: 'Generate Access Code',
      accessCodeData: {
        result: ''
      }
    }
  },

  computed: {
    ...mapGetters(['authUser']),
  },

  methods: {
    onSubmit() {
      getAccessCode(this.authUser.id)
        .then((data) => {
          this.accessCodeData.result = data["data"]
         })
        .catch((data) => {
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/GenerateAccessCode.vue